import React, { useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import Instructor from './Advanced/Instructor';
import { StyledInputContainer } from './index.styles';
import ControlledInput from '../../../components/forms/ControlledInput';
import { ClassStatus } from '../../../context/types';
import { ClassContainer } from '../ClassContainer';
import RequiredIcon from '../RequiredIcon';

interface DetailsProps {
    admin?: boolean;
}

const Details: React.FC<DetailsProps> = ({ admin = false }) => {
    const { t } = useTranslation('create_edit_class');
    const { control, formActionType, classRecord, handleClassNameFocus, zoomAppId } = useContainer(ClassContainer);
    const passcodeInputRef = useRef<HTMLInputElement>(null);
    const classNameInputRef = useRef<HTMLInputElement>(null);
    const isTeams = zoomAppId === 'teams';

    const onPasscodeClick = () => {
        if (passcodeInputRef) {
            // this solution also works on safari/mac client
            passcodeInputRef.current?.select();
        }
    };

    const onClassNameClick = () => {
        if (classNameInputRef) {
            // this solution also works on safari/mac client
            classNameInputRef.current?.select();
        }
    };

    const renderInstructorField = () => {
        if (!admin) {
            return null;
        }

        if (formActionType === 'EDIT' && classRecord?.status === ClassStatus.Draft) {
            return <Instructor />;
        }

        if (formActionType === 'CREATE') {
            return <Instructor />;
        }

        return null;
    };

    return (
        <div>
            <StyledInputContainer>
                <ControlledInput
                    fullWidth
                    onFocus={handleClassNameFocus}
                    inputRef={classNameInputRef}
                    onClick={onClassNameClick}
                    placeholder={t('details.enter-class-name')}
                    label={
                        <>
                            {t('details.class-name')} <RequiredIcon />
                        </>
                    }
                    name="className"
                    control={control}
                />
            </StyledInputContainer>
            <StyledInputContainer>
                <ControlledInput
                    fullWidth
                    placeholder={t('details.enter-class-id')}
                    label={t('details.class-id')}
                    name="classId"
                    control={control}
                />
            </StyledInputContainer>
            <StyledInputContainer>
                <ControlledInput
                    fullWidth
                    placeholder={t('details.enter-description')}
                    label={t('details.description')}
                    name="description"
                    control={control}
                />
            </StyledInputContainer>
            {!isTeams && (
                <StyledInputContainer>
                    <ControlledInput
                        fullWidth
                        inputProps={{ maxLength: 10 }}
                        inputRef={passcodeInputRef}
                        onClick={onPasscodeClick}
                        placeholder={t('details.enter-class-passcode')}
                        label={
                            <>
                                {t('details.class-passcode')} <RequiredIcon />
                            </>
                        }
                        name="classPasscode"
                        control={control}
                    />
                </StyledInputContainer>
            )}

            {renderInstructorField()}
        </div>
    );
};

export default Details;
